import { ForYouRibbon } from "@/types/for-you"

/**
 * Server-pushed homepage ribbon events (BroadcastService MESSAGE_FOR_YOU):
 * rows landing, being replaced, retired, or awaiting an edit, plus the
 * ForYouAgent run starting and finishing. The ribbon list is patched in
 * place; nothing refetches on an event.
 */
export type ForYouEvent =
  | { event: "run_started" }
  | { event: "run_finished" }
  | { event: "ribbon_added"; ribbon: ForYouRibbon }
  | {
      event: "ribbon_replaced"
      ribbon: ForYouRibbon
      replaces_ref: string | null
    }
  | { event: "ribbon_retired"; ref: string }
  | { event: "ribbon_updating"; ref: string; feedback_ref: string }
  /** the agent closed a feedback line without a row; ref is null for a page-bottom note */
  | {
      event: "feedback_closed"
      feedback_ref: string
      ref: string | null
      outcome: "noted" | "failed"
      message: string
    }

type Listener = (event: ForYouEvent) => void

const listeners = new Set<Listener>()

export function dispatchForYouEvent(event: ForYouEvent) {
  listeners.forEach((listener) => listener(event))
}

/** Subscribe; returns the unsubscribe function. */
export function onForYouEvent(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
